module.exports = __webpack_public_path__ + "svg/logo-secondary.svg";